
import React, { useState } from 'react';
import { Cloud, Cpu } from 'lucide-react';
import { useTranscriptionMode } from '../contexts/TranscriptionModeContext';
import { isModelLoaded } from '../services/localTranscriptionService';
import LocalModelSettings from './LocalModelSettings';

const TranscriptionModeToggle: React.FC = () => {
  const { mode, isLocal, toggleMode } = useTranscriptionMode();
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClick = () => {
    if (mode === 'cloud' && !isModelLoaded()) {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 3000);
    }
    toggleMode();
  };

  return (
    <div className="relative">
      <div
        className="flex items-center gap-0.5 bg-base-200 dark:bg-dark-200 rounded-xl p-1 border border-base-300 dark:border-dark-300"
        role="group"
        aria-label="Transcription mode"
      >
        <button
          onClick={mode !== 'cloud' ? handleClick : undefined}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-all duration-200 ${
            mode === 'cloud'
              ? 'bg-brand-primary text-white shadow-sm shadow-brand-primary/30'
              : 'text-base-content/50 dark:text-dark-content/50 hover:text-base-content dark:hover:text-dark-content'
          }`}
          title="Cloud mode (Gemini API)"
        >
          <Cloud size={13} />
          <span className="hidden sm:inline">Cloud</span>
        </button>

        <button
          onClick={mode !== 'local' ? handleClick : undefined}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-all duration-200 ${
            mode === 'local'
              ? 'bg-brand-primary text-white shadow-sm shadow-brand-primary/30'
              : 'text-base-content/50 dark:text-dark-content/50 hover:text-base-content dark:hover:text-dark-content'
          }`}
          title="Local mode (Whisper, runs in-browser)"
        >
          <Cpu size={13} />
          <span className="hidden sm:inline">Local</span>
        </button>
      </div>

      {showTooltip && (
        <div className="absolute top-full mt-2 right-0 z-50 w-52 bg-dark-100 text-white text-[11px] leading-relaxed px-3 py-2 rounded-xl shadow-xl border border-dark-300 animate-fade-in">
          <span className="font-bold block mb-0.5">First-time setup</span>
          A ~77MB Whisper model will download and cache in your browser. Subsequent uses are instant.
        </div>
      )}

      {mode === 'local' && (
        <div className="absolute top-full mt-2 right-0 z-40 w-64 bg-white dark:bg-dark-100 rounded-xl shadow-xl border border-base-300 dark:border-dark-300 px-3 py-2">
          <LocalModelSettings />
        </div>
      )}
    </div>
  );
};

export default TranscriptionModeToggle;
